































import { Vue, Component } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import swatchTabs from '@/components/organism.swatch.tabs.vue';
import swatchesWrapper from '@/components/Swatches/SwatchesWrapper';
import ugcTrayWrapper from '@/components/UGC/Tray/TrayWrapper';
import palettes from '@/components/Swatches/Palettes';
import paletteModal from '@/components/Swatches/PaletteModal';
import featureTabModal from '@/components/Modals/FeatureTabs/FeatureTabModal.vue';
import pickYourOwnColorTray from '@/components/PickYourOwnColorTray';
import swatchTrayMixin from '@/mixins/swatchTray';
import tabs from '@/components/Swatches/TabsComponent';

@Component({
  components: {
    CustomContainer,
    featureTabModal,
    swatchTabs,
    tabs,
    palettes,
    paletteModal,
    pickYourOwnColorTray,
    swatchesWrapper,
    ugcTrayWrapper,
  },
  mixins: [swatchTrayMixin]
})
export default class SwatchTray extends Vue {

};
